import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Colors } from "../../../../helpers/Colors";
import { fontSize } from "../../../../helpers/fontSize";
import axios from "axios";
import { DatePicker } from "@material-ui/pickers";
import { BsCalendarEvent } from "react-icons/bs";
import { BiTime } from "react-icons/bi";
import lime from "@material-ui/core/colors/lime";
import { TimePicker } from "@material-ui/pickers";
import { format } from "date-fns";
import toast from "react-hot-toast";
import { ax_cancelBooking } from "../../../../api/reservation";

const useStyles = makeStyles({
  Page: {
    "& .MuiFormControl-root, .MuiTextField-root": {
      display: "none !important",
    },
    "& .MuiInputBase-input, .MuiInput-input": {
      display: "none !important",
    },
    "& ..MuiPickersToolbar-toolba": {
      backgroundColor: `${Colors.secondary} !important`,
    },
    //  padding: "20px 25px",
    width: "100%",
    backgroundColor: Colors.pageBg,
    overflow: "scroll",

    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-Width: 770px) ": {
      // padding: "10px 15px",
    },
  },
  Page_Content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  Input_Container: {
    backgroundColor: Colors.sidebarWhite,
    //  padding: "20px 30px",
    borderRadius: "10px",
    // overflow: "scroll",
    "@media only screen and (max-Width: 770px) ": {
      // padding: "10px 15px",
      // height: "550px",
    },
  },
  Container_Two: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    // width: "100%",
    "& .delete": {
      width: "450px",
      "@media only screen and (max-Width: 770px) ": {
        width: "400px",
      },
      "& div": {
        fontWeight: 440,
        fontSize: fontSize.modalInput,
        padding: "0px 0px 15px 0px",
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.Tablet_paragraph,
          padding: "0px 0px 10px 0px",
        },
        "& .content": {
          color: Colors.primary,
          fontWeight: 600,
        },
      },
    },
    "& .CabinName_Con": {
      display: "flex",
      flexDirection: "column",
      width: "450px",
      padding: "0px 0px 15px 0",
      "@media only screen and (max-Width: 770px) ": {
        display: "flex",
        flexDirection: "column",
        width: "400px",
      },
      // "@media (min-Width: 770px) and (max-Width: 1100px) ": {
      //   width: "250px",
      // },
      "& label": {
        fontSize: fontSize.modalInput,
        fontWeight: 500,
        color: Colors.secondary,
        //   "@media only screen and (max-Width: 770px) ": {
        //     fontSize: fontSize.label,
        //   },
      },
      "& input": {
        fontWeight: 500,
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.primaryExtraLight2,
        fontSize: fontSize.modalInput,
        borderRadius: "5px",
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {
          //  fontSize: fontSize.label,
          padding: "6px 8px 8px 8px",
        },
        "& option": {
          maxHeight: "100px",
          overflowY: "scroll",
        },
      },
      "& ::placeholder": {},
    },
    "& .Submit_Button": {
      width: "450px",
      padding: "0px 0px 0px 0",
      margin: "10px 0px 0px 0px",
      "@media only screen and (max-Width: 770px) ": {
        width: "100%",
        padding: "10px 0 0 0",
        margin: "0px 0px 0px 0px",
      },
      "& .delete_button": {
        margin: "0px 0px 0px 5px",
        "& button": {
          cursor: "pointer",
          padding: "10px 10px",
          width: "100%",
          margin: "0px 0px 0 0",
          outline: "none",
          border: `2px solid ${Colors.error}`,
          backgroundColor: Colors.error,
          fontSize: "16px",
          fontWeight: 500,
          borderRadius: "5px",
          color: Colors.white,
        },
      },
      "& .disabled_button": {
        margin: "0px 0px 0px 5px",
        "& button": {
          padding: "10px 10px",
          width: "100%",
          margin: "0px 0px 0 0",
          outline: "none",
          border: `2px solid ${Colors.greyLight}`,
          backgroundColor: Colors.greyLight,
          fontSize: "16px",
          fontWeight: 500,
          borderRadius: "5px",
          color: Colors.secondary,
        },
      },
      "& button": {
        cursor: "pointer",
        padding: "10px 10px",
        width: "100%",
        margin: "0px 0px 0 0",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.primary,
        fontSize: "16px",
        borderRadius: "5px",
        color: Colors.sidebarWhite,
        "@media only screen and (max-Width: 770px) ": {
          width: "fit-content",
        },
      },
    },
  },
  OrginalaDatePicker: {},
  datePicker: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "10px",
    border: `2px solid ${Colors.inputBg}`,
    backgroundColor: Colors.primaryExtraLight2,
    borderRadius: "5px",
    "& .Calender_Con": {
      fontWeight: "bold",
      color: Colors.tableRowsText,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .calenderIconCon": {
        //   border: `0px solid ${Colors.sidebarWhite}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .calenderIcon": {
          fontSize: "25px",
          padding: "0px",
          color: Colors.primary,
          //  backgroundColor: Colors.white,
        },
      },
    },
    "& .date_time_Con": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      margin: "0px 0px 0px 5px",

      "& .date": {
        fontWeight: 500,
        fontSize: "16px",
        color: Colors.secondary,
        display: "flex",
        alignItems: "center",
        margin: "0 0 0 10px",
        // justifyContent: "flex-start",
        // margin: "0px 0px 0px 10px",
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.label,
        },
      },
      "& .time": {
        margin: "0px 0px 0px 0px",
        fontWeight: 500,
        fontSize: "16px",
        color: Colors.textGrey,
        display: "flex",
        alignItems: "center",
        // justifyContent: "flex-start",
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.label,
        },
      },
    },
    "& div": {
      "& .date": {
        fontSize: 16,
        color: Colors.grey,
      },
      "& .time": {
        fontSize: 14,
        color: Colors.grey,
      },
    },
  },
  Container_Six: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "full",
    "& .Submit_Button": {
      width: "100%",
      fontWeight: 600,
      padding: "0px 0px 0px 0",
      "& button": {
        width: "100%",
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.primary}`,
        backgroundColor: Colors.primary,
        fontSize: "16px",
        borderRadius: "5px",
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {},
      },
    },
  },
});

const Delete_Model = ({
  name,
  showCancelModal,
  setShowCancelModal,
  selectedID,
  setSelectedID,
  enteredDeleteContent,
  setEnteredDeleteContent,
  triggerUseEffect,
  setUseEffect,
}) => {
  const classes = useStyles();
  // const [getCabins, setGetCabins] = useState([]);
  // const [updatedDate, setUpdatedDate] = useState(new Date());
  // const [updatedStartTime, setUpdatedStartTime] = useState(new Date());
  // const [updatedEndTime, setUpdatedEndTime] = useState(new Date());
  // const [dayClicked, setDayClicked] = useState(false);
  // const [startTimeClicked, setStartTimeClicked] = useState(false);
  // const [endTimeClicked, setEndTimeClicked] = useState(false);

  const [isEqual, setIsEqual] = useState(false);

  // const UpdateReservationHandler = (e) => {
  //   e.preventDefault();
  //   const data = { ...selectedID };
  //   axios
  //     .put("/api/put/updateBooking", data)
  //     .then((res) => {
  //       //   console.log("The res in @updateBooking", res);
  //       setShowCancelModal(false);
  //       setUseEffect(true);
  //       res.data.key === "Success"
  //         ? toast.success(res.data.data)
  //         : toast.error(res.data.data);
  //     })
  //     .catch((err) => {
  //       console.log("Error @UpdateReservationHandler", err);
  //     });
  // };

  const DeleteReservationHandler = async (id) => {
    try {
      const ax = await ax_cancelBooking(id);
      console.log("ax:- " + ax);
      if (ax.code === 200) {
        console.log(`Reservation Deleted! is: ${id}`);
        setUseEffect(!triggerUseEffect);
        setEnteredDeleteContent("");
        toast.success(ax.data);
        setShowCancelModal(false);
      } else {
        toast.error(ax.data);
      }
    } catch (e) {
      console.log("Error @DeleteReservationHandler:- ", e);
    }
  };

  useEffect(() => {
    if (selectedID !== null) {
      console.log("selected Delete Content === !null");
      if (selectedID._id === enteredDeleteContent) {
        setIsEqual(true);
      } else {
        setIsEqual(false);
      }
    } else {
      setIsEqual(false);
    }
  }, [enteredDeleteContent, isEqual]);

  return (
    <main className={classes.Page}>
      <main className={classes.Page_Content}>
        <main
          //  onSubmit={UpdateReservationHandler}
          className={classes.Input_Container}
        >
          {/* {JSON.stringify(selectedID.cabinName)}
         {JSON.stringify(format(selectedID.selectedDay, "dd/MM/yyyy"))} 
          {JSON.stringify(selectedID.day)}
          {JSON.stringify(selectedID.startTime)}
          {JSON.stringify(selectedID.endTime)} */}
          <section className={classes.Container_Two}>
            <div className="delete">
              <div>
                To {name === "Cabin" ? "delete" : "cancel"} this{" "}
                <span className="name">{name}</span>{" "}
                <span className="content">
                  {selectedID !== null ? selectedID._id : ""}
                </span>
                , type the above-mentioned{" "}
                <span className="content">Booking ID</span> to confirm.
              </div>
            </div>
            <div className="CabinName_Con">
              <label>{name} ID</label>
              <input
                type={"text"}
                placeholder={`Enter the ${name} ID`}
                value={enteredDeleteContent}
                onChange={(e) => {
                  setEnteredDeleteContent(e.target.value);
                }}
              ></input>
            </div>
            <div className="Submit_Button">
              {isEqual ? (
                <div
                  className="delete_button"
                  onClick={() => DeleteReservationHandler(selectedID._id)}
                >
                  <button>Delete</button>
                </div>
              ) : (
                <div className="disabled_button">
                  <button disabled={!isEqual}>Delete</button>
                </div>
              )}
            </div>
          </section>
          {/* <section
            className={classes.Container_Six}
            onClick={UpdateReservationHandler}
          >
            <div className="Submit_Button">
              <div className="SubmitText_Con">
                <button type="submit">Update</button>
              </div>
            </div>
          </section> */}
        </main>
      </main>
    </main>
  );
};

export default Delete_Model;
